import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgAu48Rounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  "aria-label": "Australia",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#e7e7e7",
  d: "M12 22A10 10 0 1 0 2 12a10 10 0 0 0 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002776",
  d: "M3.22 7.19c-.13.24-.25.49-.36.74L4 7.19zm2.64-3.08c-.22.18-.44.35-.64.54l.64.42z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#252f6b",
  d: "M13.55 2.13v.38L9.2 5.28h4.35v1.9H9.2L13.55 10v.72h-1L7.37 7.39v3.28H5.88V7.39L2.27 9.71A9.7 9.7 0 0 0 2 12a10 10 0 1 0 11.55-9.87M6.23 17.59l-.82-.86-.82.86.16-1.17-1.18-.1 1-.61-.66-1 1.09.43.41-1.14.37 1.13 1.11-.41-.66 1 1 .61-1.18.1zM17.29 8l.53.2.18-.54.17.54.53-.2-.31.46.49.3-.57.05.08.55L18 9l-.39.4.07-.55-.57-.05.5-.3zm-2 4.77-.39-.4-.39.4.08-.56-.59-.05.49-.29-.31-.46.53.2.17-.54.18.54.53-.2-.32.46.5.29-.57.05zm3.15 5-.39-.4-.39.4.07-.55-.57-.05.5-.29-.32-.47.53.2L18 16l.17.54.53-.2-.31.47.49.29-.57.05zm1.7-7.18.53.2.18-.54.18.54.53-.2-.32.47.49.29h-.56l.07.55-.39-.4-.39.4.07-.55h-.56l.49-.29zm-.84 2.18.14.35h.36l-.28.24.09.35-.3-.18-.3.18.09-.35-.28-.24h.36z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002776",
  d: "M12.16 2H12a9.94 9.94 0 0 0-4.63 1.14v1.93z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m6.23 15.7.66-1-1.11.42L5.42 14l-.36 1.12-1.12-.42.66 1-1 .61 1.19.11-.19 1.17.82-.86.81.86-.16-1.17 1.18-.11zm12.16 1.15.3-.47-.52.2L18 16l-.18.54-.53-.2.32.47-.5.29.57.05-.07.56.39-.41.39.41-.08-.56.56-.05zm-3.15-4.98.31-.48-.55.21-.17-.53-.17.53-.53-.21.31.48-.49.29.57.05-.08.56.39-.42.39.42-.08-.56.56-.05zm2.44-3.06-.07.55L18 9l.39.4-.08-.55.56-.06-.48-.29.3-.46-.52.2-.17-.58-.18.54-.53-.2.32.46-.5.29zm2.8 2.56-.08.57.39-.42.39.42-.08-.57h.57l-.49-.37.32-.47-.54.2-.17-.54-.17.54-.53-.2.31.47-.48.29zM19 13.34l-.09.35.31-.19.31.19-.09-.35.28-.23h-.36l-.14-.35-.13.35h-.36z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e00034",
  d: "M5.86 7.19h-.74L2.51 8.87a7 7 0 0 0-.19.63l3.54-2.26zM4.79 5.08c-.06.08-.14.14-.2.22h.53zm3.32 2.11 5.44 3.47v-.5l-4.64-3zm-.74-1.91h.74l5-3.22c-.24 0-.47-.05-.71-.06L7.37 5.26z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M6.15 3.89a2 2 0 0 0-.27.22v1l-.66-.42-.43.42.33.21h-.53l-.32.36h1.87V3.89zm7.4 1.76v-.37H9.2l4.35-2.77v-.38a2.4 2.4 0 0 0-.4 0l-5 3.2h-.78L12.44 2h-.28L7.37 5.07V3.14l-.28.15v2.35h6.46zM7.08 10.7h.29V7.42l5.14 3.28h1l-5.4-3.51h.8l4.64 3V10L9.2 7.19h4.35v-.35H7.08zm-1.22 0h.28V6.84h-2.7a3 3 0 0 0-.2.35H4l-1.17.74a8 8 0 0 0-.35.93l2.64-1.67h.74l-3.54 2.3a2 2 0 0 0 0 .21l3.54-2.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff1300",
  d: "M6.15 10.7h.94V6.84h6.48V5.65H7.08V3.3a10 10 0 0 0-.94.59v1.76H4.27a11 11 0 0 0-.84 1.19h2.71v3.86z"
}));

export { SvgAu48Rounded as default };
//# sourceMappingURL=Au48Rounded.js.map
